import React, { useState, useEffect } from "react";
import Typing from "react-typing-animation";
import { useAlert } from "react-alert";
import { useForm, ValidationError } from "@formspree/react";
import { PropagateLoader } from "react-spinners";
import Particle from "../../Components/Particle";

import "./Contact.css";
import "../../loadingStyle.css";

function Contact() {
  const [loading, setLoading] = useState(true);
  const alert = useAlert();
  const [state, handleSubmit] = useForm("xyylelyd");

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 850);
    return () => clearTimeout(loadingTimeout);
  }, []);

  const handleClick = () => {
    return alert.success(
      <div
        style={{
          textTransform: "initial",
        }}
      >
        Message Sent Successfully, Thank you!
      </div>
    );
  };

  return (
    <div>
      {loading ? (
        <div className="loading">
          <PropagateLoader color="#F9880D" loading={loading} size={15} />
        </div>
      ) : (
        <div>
          <div className="contact__content">
            <Particle />
            <div className="contact__content__heading">
              <Typing
                cursorClassName="custom"
                cursor={<span> _ </span>}
                speed={80}
              >
                <h1> Contact me! </h1>
              </Typing>
            </div>
            <div>
              <div className="contact__content__content">
                <p>
                  I am interested in open source opportunities.However, If you
                  have any questions, don 't hesitate to contact me using below
                  form.
                </p>
              </div>
              <div className="contact__content__user__inputs">
                <form action="/" method="POST" onSubmit={handleSubmit}>
                  <input
                    type="name"
                    name="name"
                    className="contact__content__user__inputs__name"
                    placeholder="Name"
                  />
                  <input
                    type="email"
                    name="email"
                    className="contact__content__user__inputs__email"
                    placeholder="Email"
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                  <input
                    type="text"
                    name="subject"
                    className="contact__content__user__inputs__subjectmessage"
                    placeholder="Subject"
                  />
                  <textarea
                    type="text"
                    name="message"
                    className="contact__content__user__inputs__subjectmessage"
                    rows="10"
                    wrap="soft"
                    id="message"
                    placeholder="Message"
                  />
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                  />
                  <button
                    className="contact__content__user__inputs__button"
                    type="submit"
                    onClick={handleClick}
                    disabled={state.submitting}
                  >
                    SEND
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="contact__image">
            <iframe
              title="map"
              className="map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=80.61561584472658%2C26.711880280633007%2C81.25831604003908%2C27.13981255901822&amp;layer=mapnik&amp;marker=26.926305007309246%2C80.93696594238281"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contact;
